import { put, takeEvery } from "redux-saga/effects"
import { fetchGraphMethod } from "../../../services/httpService"
import messagePopup from "../../../utils/messagePopup"

// ========================================== Action Type =====================================================
export const actionType = {
    SCHOOL_CURRENT_LEVEL_LIST_START: 'SCHOOL_CURRENT_LEVEL_LIST_START',
    SCHOOL_CURRENT_LEVEL_LIST_SUCCESS: 'SCHOOL_CURRENT_LEVEL_LIST_SUCCESS',
    SCHOOL_CURRENT_LEVEL_LIST_FAILED: 'SCHOOL_CURRENT_LEVEL_LIST_FAILED'
}

// ============================================ Actions ========================================================
export const schoolCurrentLevelListStart = (data) => ({
   type: actionType.SCHOOL_CURRENT_LEVEL_LIST_START,
   payload: data
})

export const schoolCurrentLevelListSuccess = (data) => ({
    type: actionType.SCHOOL_CURRENT_LEVEL_LIST_SUCCESS,
    payload: data
})

export const schoolCurrentLevelListFailed = (data) => ({
    type: actionType.SCHOOL_CURRENT_LEVEL_LIST_FAILED,
    payload: data
})

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null
}

export default function schoolCurrentLevelListReducer(state = INIT_STATE,action){
  switch(action.type){
      case actionType.SCHOOL_CURRENT_LEVEL_LIST_START: 
        return {
            ...state,
            loading: true
        }
      case actionType.SCHOOL_CURRENT_LEVEL_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            data: action.payload,
            error: null
        }  
      case actionType.SCHOOL_CURRENT_LEVEL_LIST_FAILED:
        return {
            ...state,
            loading: false,
            data: null,
            error: action.payload
        }       
      default: return {...state}  
  }
} 

// ===================================================== side effect =============================================

export function* schoolCurrentLevelListSaga(action){
   try {
    const response = yield fetchGraphMethod(action.payload.query,action.payload.variables,true);
    if(response && response.status === 200){
       const allSchoolcurrentlevels = response.data.data.allSchoolcurrentlevels.Schoolcurrentlevels ? response.data.data.allSchoolcurrentlevels.Schoolcurrentlevels : null
       yield put(schoolCurrentLevelListSuccess(allSchoolcurrentlevels));
    } else {
      messagePopup('','School Current Level List failed','error')   
      yield put(schoolCurrentLevelListFailed('School Current Level List failed')) 
    }
   } catch (error) {
     messagePopup('','School Current Level List failed','error')   
     yield put(schoolCurrentLevelListFailed('School Current Level List failed')) 
   }
}

export function* watchSchoolCurrentLevelListSaga(){
    yield takeEvery(actionType.SCHOOL_CURRENT_LEVEL_LIST_START, schoolCurrentLevelListSaga)
}